module.exports = __webpack_public_path__ + "static/media/cell.0cc4abb8.png";